import Swal, { SweetAlertCustomClass } from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import moment from 'moment'

const swal = withReactContent(Swal);

const Utility = {
    getQueryStringByName(name: string) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name)
    },

    validate: {
        Notblank: function (value: string) {
            if (!(value.length > 0)) {
                throw "Value could not be blank";
            }
        },

        Email: function (value: string) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(value)) {
                throw "Please input correct email";
            }
        },
    },

    Alert: {
        Error: function (msg: string | unknown) {
            Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            }).fire({ icon: 'error', text: (msg as string) })
        },
        Success: function (msg: string | unknown) {
            Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            }).fire({ icon: 'success', title: (msg as string) });
        },
        Info: function (msg: string | unknown, time?: number) {
            Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: time ? time : 30000,
                showCloseButton: true,
                customClass: { title: "info-title" } as SweetAlertCustomClass,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            }).fire({ icon: 'info', title: (msg as string) });
        },
        Warning: function (msg: string | unknown) {
            Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            }).fire({ icon: 'warning', title: (msg as string) });
        },
    },

    DateFormat: {
        getDateDDMMYYYY: (dateTime: number) => {
            const date = new Date(dateTime);
            return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
        },
        getTime: (dateTime: number) => {
            const date = new Date(dateTime);
            const hour = date.getHours() < 10 ? "0" + date.getHours().toString() : date.getHours().toString();
            const minute = date.getMinutes() < 10 ? "0" + date.getMinutes().toString() : date.getMinutes().toString();
            const second = date.getSeconds() < 10 ? "0" + date.getSeconds().toString() : date.getSeconds().toString();

            return hour + ":" + minute + ":" + second;
        },
        format: (date: Date) => {
            //format date: 01 Dec 21
            return moment(date).format("DD MMM YY");
        },
        formatDDMMMYYhhss: (date: Date) => {
            return moment(date).format("DD MMM YY HH:mm");
        },
        formatDDMMMYYhhssAmPm: (date: Date) => {
            return moment(date).format("DD MMM YY HH:mm A");
        },
        formatDDMMMYYhhssString: (dateString: string) => {
            if (!dateString || dateString.length === 0) {
                return "";
            }

            let date = new Date(dateString);
            //format date: 01 Dec 21
            return moment(date).format("DD MMM YY HH:mm");
        },
        formatDateString: (dateString: string) => {
            if (!dateString || dateString.length === 0) {
                return "";
            }

            let date = new Date(dateString);
            //format date: 01 Dec 21
            return moment(date).format("DD MMM YY");
        },
        formatDateStringFullYear: (dateString: string) => {
            if (!dateString || dateString.length === 0) {
                return "";
            }

            let date = new Date(dateString);
            //format date: 01 Dec 21
            return moment(date).format("DD MMM YYYY");
        },
        getIsoDate: (date: string) => {
            return moment(date).toISOString();
        },
        isValidDate: (date: string) => {
            return !isNaN(moment(date).toDate().getTime());
        },
    },

    NumberFormat: {
        formatUSD: (value: number) => {
            return value == null ? 0 : parseFloat(value.toFixed(2)).toLocaleString('en-US');
        },
        formatVND: (value: number) => {
            return value == null ? 0 : Math.round(value).toLocaleString('en-US');
        }
    },

    CloneObject: (obj: any) => {
        return JSON.parse(JSON.stringify(obj));
    },

    addDaysToDate: (date: Date, days: number) => {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    },

    propertyOf: <T>(name: keyof T) => {
        return name.toString();
    }
}

export default Utility;